module.exports = __webpack_public_path__ + "img/en-pc-s5.7e0f4eb2.png";